<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType ?? ''" [nzErrorTip]="errorMessage">
    <nz-input-group [nzAddOnAfter]="" [nzPrefixIcon]="prefixIcon" [nzSuffix]="suffixIconName ? suffixIcon : ''">
      <input nz-input [id]="code" [(ngModel)]="value" (change)="inputChanged()" (keyup)="inputTypedCheck()"
        (keyup.enter)="inputChanged()" [readOnly]="disabled" [placeholder]="title" autocomplete="off"
        [attr.maxlength]="maxLength" [disabled]="disabled" />
    </nz-input-group>
  </nz-form-control>
</nz-form-item>
<ng-template #suffixIcon>
  <i [class]="suffixIconName"></i>
</ng-template>